import { BuildingClient } from "../../client/BuildingClient"
import {EventScheduleClient, EventType} from "../../client/EventScheduleClient"
import { useEffect, useState } from "react"
import { Building } from "../BuildingStatus"
import { MultipleBuildingInput } from "../MultipleBuildingInput"
import { Calendar } from "../calendar/Calendar"
import { useEntitlements } from "../../EntitlementProvider"
import { NotificationClient as NotificationClient } from "../../client/NotificationsClient"
import {TimeZoneSelector} from "../common/TimeZoneSelector";
import {Timezone} from "../../time/Timezone";
import {Permission} from "../../Permission";

export interface CalendarPageProps {
    buildingClient: BuildingClient
    eventClient: EventScheduleClient
    notificationClient: NotificationClient
    refreshTime: number | null
}
export const CalendarPage = ({ buildingClient, eventClient, notificationClient, refreshTime = null }: CalendarPageProps) => {
    const [eventTypes, setEventTypes] = useState<EventType[]>([])
    const [selectedBuildings, setSelectedBuildings] = useState<Building[]>([])
    const [selectedTimezone, setSelectedTimezone] = useState<Timezone>(Timezone.getUserTimezone())
    const [buildings, setBuildings] = useState<Building[]>([])

    const entitlements = useEntitlements()

    useEffect(() => {
        buildingClient.retrieveBuildings().then(setBuildings)
    }, [buildingClient])

    useEffect(() => {
        const run = async () => {
            const eventTypes: EventType[] = await eventClient.getEventTypes()
            setEventTypes(eventTypes)
        }
        run()
    }, [eventClient, entitlements])

    return <div className={'container-calendar'}>
        <div style={{marginBottom: '1rem'}} className={'row'}>
            <div className={'col'}>
                <MultipleBuildingInput buildingsSource={buildings} onChange={setSelectedBuildings}/></div>
            {entitlements.has(Permission.WRITE_TIMEZONE) && <div className={'col'}><TimeZoneSelector initial={selectedTimezone} onChange={(e) => {
                setSelectedTimezone(e)
            }} options={Timezone.getAll()}/>
            </div>}
        </div>
        <Calendar
            selectedTimeZone={selectedTimezone}
            buildings={buildings}
            eventClient={eventClient}
            buildingClient={buildingClient}
            notificationClient={notificationClient}
            eventTypes={eventTypes}
            selectedBuildings={selectedBuildings}
            refreshTime={refreshTime} />
    </div>
}
